/** Dominio del VPS TNO Media Lab (media lab de TNO Network). */
export function isTnoMediaLabHost() {
  if (typeof window === 'undefined') return false;
  const host = String(window.location.hostname || '')
    .toLowerCase()
    .replace(/\.$/, '');
  return (
    host === 'tnomedialab.com' ||
    host === 'www.tnomedialab.com' ||
    host === 'server1.tnomedialab.com' ||
    host === '162.0.214.75'
  );
}

export function isMediaLabCreatorsPath(pathname) {
  const p = String(pathname || '')
    .replace(/\/+$/, '')
    .toLowerCase() || '/';
  return p === '/creadores' || p === '/talentos' || p === '/medialab';
}

export const TNO_MEDIA_LAB_NAME = 'TNO Media Lab';
export const TNO_MEDIA_LAB_LOGO = '/images/tno-media-lab/logo.svg?v=2';
export const TNO_MEDIA_LAB_CREATORS_PATH = '/creadores';
